import { getDisputesAccessStatus } from "@redotech/redo-dispute-common/disputes-access-status";
import { DEFAULT_RECLAIM_ACCESS_DEFAULTS } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import type { Team } from "@redotech/redo-team-common/team";
import { hasReclaimShopifyPermissions } from "../../../payments/chargebacks/disputes-shopify-permissions";

/**
 * Single source of truth for how disputes setup state is read from a Team.
 * Predicates call these accessors so the field paths into team.settings live
 * in one place — if the settings shape ever changes, only this file updates.
 *
 * Mirrors the access patterns used by disputes-enabled-gate.tsx today.
 */

export function isReclaimSetupComplete(team: Team): boolean {
  return team.settings?.disputes?.enabled === true;
}

export function isAiAutomationEnabled(team: Team): boolean {
  return getDisputesAccessStatus(
    team,
    new Date(),
    DEFAULT_RECLAIM_ACCESS_DEFAULTS,
  ).canUseAutomation;
}

/** True when the team owes nothing now (trial / free / accepted). Uses
 * requiresBilling (not billingAccepted) so active trials don't regress. */
export function isDisputesBillingSatisfied(team: Team): boolean {
  return !getDisputesAccessStatus(
    team,
    new Date(),
    DEFAULT_RECLAIM_ACCESS_DEFAULTS,
  ).requiresBilling;
}

export function getEvidenceWindowDays(team: Team): number | null {
  const value = team.settings?.disputes?.evidenceWindowDays;
  return typeof value === "number" ? value : null;
}

export function teamHasDisputeScopes(team: Team): boolean {
  return hasReclaimShopifyPermissions(team);
}
